import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {GuestPage, PageNotFound, PageTwo, Recovery, RegisterPage} from './Components/Pages';
import {
    UCPCharacterStatistics,
    UCPCreateCharacter,
    UCPMain,
    UCPRetestCharacter,
    UCPSettings
} from './Components/UCPPages';
import {ACPCheckApplication, ACPCheckCharacters} from './Components/ACPPages';
import {ShopMain} from "./Components/Shop/Shop";
import {useState} from 'react';
import {ShopFavorites} from "./Components/Shop/ShopFavorites";
import {ShopBuy} from "./Components/Shop/ShopBuy";
import MainLink from "./Components/Link";
import {ShopPay} from "./Components/Shop/ShopPagePay";

const ucp_get_donate = `${MainLink()}api/ucp/get-donate`;

function UCP(){
    const [donateBalance, setDonateBalance] = useState(0);
    const fetchDonate = async () => {
        try {
            const userId = localStorage.getItem("user-id");
            const userName = localStorage.getItem("user-login");
            const userPassword = localStorage.getItem("user-password");

            const urlWithParams = `${ucp_get_donate}?user_id=${encodeURIComponent(userId)}&user_name=${encodeURIComponent(userName)}&user_password=${encodeURIComponent(userPassword)}`;

            const response = await fetch(urlWithParams, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                },
            });

            if (!response.ok) {
                throw new Error(`Ошибка HTTP! Статус: ${response.status}`);
            }

            const result = await response.json();
            setDonateBalance(result || 0);
        } catch (err) {
            console.error("Ошибка загрузки баланса:", err.message);
            setDonateBalance(0);
        }
    };
    fetchDonate();
  if(localStorage.getItem("jwtToken") == null){
      window.location.href = "/";
    }
  return (
    <div className='ucp-body'>
      <div className='ucp-content-container'>
        <div className='ucp-header'>
            <a href="../../../"><div className='logo-img'></div></a>
            <a href='https://forum.medieval-rp.net/' target='_blank'><span>ФОРУМ</span></a>
            <a href='https://wiki.medieval-rp.net/' target='_blank'><span>MEDIEVAL WIKI</span></a>
            <a href='/ucp/shop?category=main'> <span>МАГАЗИН</span> </a>
            <a href="/ucp/settings"><span>НАСТРОЙКИ</span></a>
            <span className='coin'>{donateBalance}</span>
        </div>

        <Routes>
          <Route path="/" element={<UCPMain />} />
          <Route path="/create-character" element={<UCPCreateCharacter />}/>
          <Route path="/statistics" element={<UCPCharacterStatistics />} />
          <Route path="/retest" element={<UCPRetestCharacter />} />
          <Route path="/settings" element={<UCPSettings />} />
        </Routes>
      </div>
    </div>
  )
}



function ACP(){
  const [admin, setAdmin] = useState(0)
  const checkAdmin = async () => {
      const acp_check_admin = `${MainLink()}api/acp/check-admin`
    try {
      const response = await fetch(acp_check_admin, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
        },
        body: JSON.stringify({
          user_id: localStorage.getItem("user-id"),
          user_name: localStorage.getItem("user-login"),
          user_password: localStorage.getItem("user-password"),
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setAdmin(result)
      if(result < 1 || result === null){
        window.location.href = "../ucp";
      }
    } catch (err) {
      console.error(err.message);
      window.location.href = "../ucp";
    } 
  };
  
  if(localStorage.getItem("jwtToken") == null){
      window.location.href = "/";
    }
  checkAdmin()
  if(admin > 0){
    return (
      <div className='ucp-body acp-bg'>
        <div className='ucp-content-container'>
          <div className='ucp-header acp'>
              <a href="../../../"><div className='logo-img'></div></a>
              <a href='https://api.medieval-rp.net/' target='_blank'><span>ЛОГИ</span></a>
              <a href='../../../../acp/check-characters'><span>ПРОВЕРКА  ЗАЯВОК</span></a>
              <span>АДМИНИСТРАТОРЫ</span>
              <span>ВЫДАЧА</span>
              <span>БЛОКИРОВКИ</span>
              <a href="../../../ucp"><span>ВЫХОД</span></a>
          </div>
          <Routes>
            <Route path="/" element={<ACPCheckCharacters />} />
            <Route path="/check-characters" element={<ACPCheckCharacters />}/>
            <Route path="/check-application" element={<ACPCheckApplication />} />
          </Routes>
        </div>
      </div>
  )
}
}

function App() {
  const isStaticFile = window.location.pathname.includes(".pdf");

  if (isStaticFile) {
    return null;
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<GuestPage />} />
        <Route path="two" element={<PageTwo />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="ucp/*" element={<UCP />} />
          <Route path="ucp/shop" element={<ShopMain/>}/>
          <Route path="ucp/shop/favorites" element={<ShopFavorites/>}/>
          <Route path="/shop/buy" element={<ShopBuy/>}/>
          <Route path="/ucp/shop/pay" element={<ShopPay />} />
          <Route path="acp/*" element={<ACP/>}/>
        <Route path="recovery" element={<Recovery />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
